module.exports = __webpack_public_path__ + "img/icons8-sign-up-in-calendar.fb178aad.svg";